import { UI } from './ui-strings';
import type { Crumb } from './head';
import type { PageMeta } from './content';

const HOME: Crumb = { name: UI.home, url: '/' };
const NEWS: Crumb = { name: UI.newsIndexTitle, url: '/news' };
const SCREENINGS: Crumb = { name: UI.portfolioIndexTitle, url: '/screenings' };

/** Where a page sits in the site hierarchy. Used for the UI and for JSON-LD. */
export function crumbsForPage(page: PageMeta): Crumb[] {
  if (page.route === '/') return [HOME];
  if (page.type === 'post') return [HOME, NEWS, { name: page.title, url: page.route }];
  if (page.type === 'liquid-portfolio') {
    return [HOME, SCREENINGS, { name: page.title, url: page.route }];
  }
  return [HOME, { name: page.title, url: page.route }];
}

export function crumbsForArchive(kind: string, name: string, route: string): Crumb[] {
  const parent = kind === 'portfolio' ? SCREENINGS : NEWS;
  if (route === '/portfolios') return [HOME, SCREENINGS, { name, url: route }];
  return [HOME, parent, { name, url: route }];
}

export { HOME, NEWS, SCREENINGS };
